import * as Sentry from '@sentry/browser'

if (['staging', 'production'].indexOf(process.env.NODE_ENV) !== -1) {
  Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: 'https://7f5ec489d5ea4470a7d109b58f4bad38@o49094.ingest.sentry.io/5228280',
  })
}

export const setSentryScope = (loadToken, email = '') => {
  Sentry.configureScope(scope =>
    scope.setUser({
      loadToken,
      email,
    })
  )
}



// WEBPACK FOOTER //
// ./utils/sentry.js